package pl.mothdigital.neuronowi.components.sections.navheader

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.graphics.*
import com.varabyte.kobweb.silk.components.text.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.common.resources.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

@Composable
fun NavHeaderLogo(
    modifier: Modifier,
) {
    val imageSrc = ImageResources.navHeaderLogo.src
    val imageDesc = ImageResources.navHeaderLogo.description
    val imageLeftRightPadding = 1.cssRem
    val firstPartName = StringResources.FIRST_PART_NAME
    val firstPartNameColor = SiteTheme.green._500
    val secondPartName = StringResources.SECOND_PART_NAME
    val secondPartNameColor = SiteTheme.green._700

    MDNavHeaderLogo(
        modifier,
        imageSrc,
        imageDesc,
        imageLeftRightPadding,
        firstPartName,
        firstPartNameColor,
        secondPartName,
        secondPartNameColor
    )
    LGNavHeaderLogo(
        modifier,
        imageSrc,
        imageDesc,
        imageLeftRightPadding,
        firstPartName,
        firstPartNameColor,
        secondPartName,
        secondPartNameColor
    )
}

@Composable
private fun LGNavHeaderLogo(
    modifier: Modifier,
    imageSrc: String,
    imageDesc: String,
    imageLeftRightPadding: CSSSizeValue<CSSUnit.rem>,
    firstPartName: String,
    firstPartNameColor: Color,
    secondPartName: String,
    secondPartNameColor: Color
) {
    Row(
        modifier = Modifier.displayIfAtLeast(Breakpoint.LG).then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            src = imageSrc,
            description = imageDesc,
            modifier = Modifier
                .height(52.px)
                .display(DisplayStyle.Block)
                .padding(leftRight = imageLeftRightPadding),
        )
        SpanText(
            modifier = TextBaseStyle.toModifier()
                .color(firstPartNameColor)
                .padding(top = 16.px)
                .fontSize((1).cssRem),
            text = firstPartName,
        )
        SpanText(
            modifier = TextBaseStyle.toModifier()
                .color(secondPartNameColor)
                .padding(top = 16.px)
                .fontSize((1).cssRem),
            text = secondPartName,
        )
    }
}

@Composable
private fun MDNavHeaderLogo(
    modifier: Modifier,
    imageSrc: String,
    imageDesc: String,
    imageLeftRightPadding: CSSSizeValue<CSSUnit.rem>,
    firstPartName: String,
    firstPartNameColor: Color,
    secondPartName: String,
    secondPartNameColor: Color
) {
    Row(
        modifier = Modifier.displayUntil(Breakpoint.LG).then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            src = imageSrc,
            description = imageDesc,
            modifier = Modifier
                .height(42.px)
                .display(DisplayStyle.Block)
                .padding(leftRight = imageLeftRightPadding),
        )
        SpanText(
            modifier = TextBaseStyle.toModifier()
                .color(firstPartNameColor)
                .padding(top = 12.px)
                .fontSize((0.9).cssRem),
            text = firstPartName,
        )
        SpanText(
            modifier = TextBaseStyle.toModifier()
                .color(secondPartNameColor)
                .padding(top = 12.px)
                .fontSize((0.9).cssRem),
            text = secondPartName,
        )
    }
}
